import * as Actions from '../../../Modules/CmsActions'
import type { Site } from '../../../Types'

interface ISiteState {
  info: Site | null
  url: string | null
}

const initialState: ISiteState = {
  info: null,
  url: null,
}

const SiteReducer = (state: ISiteState = initialState, action): ISiteState => {
  const { payload } = action

  switch (action.type) {
    case Actions.LOADED_INITIAL_SITE_VALUES:
    case Actions.SELECT_SITE:
    case Actions.FINISH_FETCH_APP_SITE:
      return { ...state, info: payload.site, url: createURL(payload.site) }

    case Actions.LOGOUT:
      return initialState

    default:
      return state
  }
}

function createURL(site: Site) {
  const { domain } = site
  const { protocol, port } = window.location

  return `${protocol}//${domain}${
    port === '80' || port === '443' ? '' : `:${port}`
  }`
}

export default SiteReducer
